// Shared form field components — defined OUTSIDE parent components to prevent focus loss on re-render
import React from 'react';

export function Field({ label, value, onChange, type = 'text', placeholder = '', step: stepVal }) {
  return (
    <div style={{ marginBottom: '.85rem' }}>
      <label style={{ fontSize: '.75rem', color: 'var(--color-text-secondary)', display: 'block', marginBottom: '.3rem', textTransform: 'uppercase', letterSpacing: '.05em', fontWeight: 500 }}>{label}</label>
      <input
        type={type}
        value={value || ''}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        step={stepVal}
        style={{ width: '100%' }}
      />
    </div>
  );
}

export function Select({ label, value, onChange, options }) {
  return (
    <div style={{ marginBottom: '.85rem' }}>
      <label style={{ fontSize: '.75rem', color: 'var(--color-text-secondary)', display: 'block', marginBottom: '.3rem', textTransform: 'uppercase', letterSpacing: '.05em', fontWeight: 500 }}>{label}</label>
      <select value={value || ''} onChange={e => onChange(e.target.value)} style={{ width: '100%' }}>
        <option value="">Select...</option>
        {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </div>
  );
}

export function TextArea({ label, value, onChange, placeholder = '', rows = 3 }) {
  return (
    <div style={{ marginBottom: '.85rem' }}>
      <label style={{ fontSize: '.75rem', color: 'var(--color-text-secondary)', display: 'block', marginBottom: '.3rem', textTransform: 'uppercase', letterSpacing: '.05em', fontWeight: 500 }}>{label}</label>
      <textarea
        value={value || ''}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        style={{ width: '100%', resize: 'vertical', fontFamily: 'var(--font-sans)', fontSize: '.83rem' }}
      />
    </div>
  );
}
